import React, { useEffect, useState } from 'react';
import PageWrapper from '../../../../components/Display/PageWrapper';
import { DataView } from 'primereact/dataview';
import { privateFetch } from '../../../../utils/apiHelper';
import { useAccountContext } from '../../../../contexts/AccountContext';
import { confirmDialog } from 'primereact/confirmdialog';
import { MultiSelect } from 'primereact/multiselect';

import ReviewPanel from './ReviewPanel';
import ReviewItem from './ReviewItem';
import styles from "../../../../components/Display/Wrapper.module.scss";

function ReviewPage({ isActive }) {
  const [reviewList, setReviewList] = useState([]);
  const { accountContext } = useAccountContext();
  const [panelIsOpen, setPanelIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedReview, setSelectedReview] = useState(undefined);
  const [filter, setFilter] = useState([]);
  const [propertyList, setPropertyList] = useState([]);
  const [layout, setLayout] = useState('grid');

  useEffect(() => {
    fetchReviewList();
  }, [filter]);

  const fetchReviewList = async () => {
    await privateFetch(
      'GET',
      'whisper',
      `/cu/${accountContext.id}/review/?properties=${filter}`
    ).then((res) => {
      setReviewList(res);
    });
  };

  const fetchPropertyList = async () => {
    await privateFetch(
      'GET',
      'resources',
      `/cu/${accountContext.id}/property/?types=wp_review`
    ).then((res) => {
      if (res) setPropertyList(res);
    });
  };

  useEffect(() => {
    fetchPropertyList();
  }, []);

  const handleDeleteReview = async (review) => {
    await privateFetch(
      'DELETE',
      'resources',
      `/cu/${accountContext.id}/review/${review.id}/`,
      "L'avis a bien été supprimé"
    ).then(() => {
      fetchReviewList();
      setSelectedReview(undefined);
    });
  };

  const updateReview = async (reviewForm) => {
    setLoading(true);
    await privateFetch(
      'PUT',
      'resources',
      `/cu/${accountContext.id}/review/${selectedReview.id}/`,
      "L'avis a bien été modifié",
      JSON.stringify(reviewForm)
    ).then(() => {
      fetchReviewList();
      setLoading(false);
      setPanelIsOpen(false);
    });
  };

  const createReview = async (reviewForm) => {
    setLoading(true);
    await privateFetch(
      'POST',
      'whisper',
      `/cu/${accountContext.id}/review/`,
      "L'avis a bien été ajouté",
      JSON.stringify(reviewForm)
    ).then(() => {
      fetchReviewList();
      setPanelIsOpen(false);
      setLoading(false);
    });
  };

  const handleCreateReview = () => {
    setSelectedReview(undefined);
    setPanelIsOpen(true);
  };

  const newReviewAction = {
    onClick: handleCreateReview,
    label: 'Ajouter un avis',
    icon: 'pi-plus'
  };

  const confirmReviewDeletion = (review) => {
    confirmDialog({
      message: 'Êtes-vous sûr de vouloir supprimer cet avis ?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Oui',
      rejectLabel: 'Annuler',
      accept: () => handleDeleteReview(review)
    });
  };

  const handleUpdateReview = (review) => {
    setSelectedReview(review);
    setPanelIsOpen(true);
  };
  const toggleLayout = () => {
    setLayout(layout === 'grid' ? 'list' : 'grid');
  };

  const changeLayoutAction = {
    onClick: toggleLayout,
    ariaLabel: "changer le mode d'affichage",
    icon: layout == "grid" ? "pi-list" : 'pi-th-large'
  };

  return (
    <div className={`h-full w-full flex-col ${isActive ? 'flex' : 'hidden'}`}>
      <PageWrapper
        label="Avis Client"
        actions={[changeLayoutAction, newReviewAction]}
      >
        <div className={styles.filterList}>

          <MultiSelect
            value={filter}
            options={propertyList}
            optionLabel="label"
            optionValue="slug"
            onChange={(e) => setFilter(e.value)}
            placeholder="Filtrer par métier"
            display="chip"
            className={styles.switchButton}
            showSelectAll={false}
            filter
          />
        </div>
        <div className={styles.pageContentContainer}>
          <div className={` ${layout === 'grid' ? styles.gridLayout : styles.listLayout}`}>
            {reviewList.map((review, index) => (
              <ReviewItem
                layout={layout}
                key={index}
                review={review}
                deleteReview={confirmReviewDeletion}
                updateReview={handleUpdateReview}
              />))}
          </div>
        </div>
        <ReviewPanel
          review={selectedReview}
          loading={loading}
          isOpen={panelIsOpen}
          onClose={() => {
            setSelectedReview(null);
            setPanelIsOpen(false);
          }}
          onCreate={createReview}
          onUpdate={updateReview}
          propertyList={propertyList}
        />
      </PageWrapper>
    </div>
  );
}

export default ReviewPage;
